// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".overflow-content[data-v-5e5cbe6c]{white-space:normal;max-height:50vh;max-width:40vw;overflow:auto;padding:8px 0;line-height:1.2}", ""]);
// Exports
module.exports = exports;
